import { type ReactNode } from "react";
import { useAuth, useClerk } from "@clerk/clerk-react";
import { useQuery } from "@tanstack/react-query";
import { getUserProfile } from "../api/userService";
import { useAxiosInstance } from "../hooks/useAxiosInstance";
import { UserContext } from "../hooks/useUserContext";

export const UserProvider = ({ children }: { children: ReactNode }) => {
  const axiosInstance = useAxiosInstance();
  const { isLoaded, isSignedIn } = useAuth();
  const { signOut } = useClerk();

  const { data, isLoading, isError } = useQuery({
    queryKey: ["user"],
    queryFn: () => getUserProfile(axiosInstance),
    enabled: isLoaded && isSignedIn,
    retry: false,
  });

  if (isError) {
    signOut();
  }

  return (
    <UserContext.Provider value={{ user: data, isLoading }}>
      {children}
    </UserContext.Provider>
  );
};
